import {DateHelper} from "@bryntum/schedulerpro";

const dayNames = DateHelper.getDayNames();
const getSchedulerDates = ({startDate, endDate}) => {
  return {
    startDate: startDate || new Date(2021, 1, 1),
    endDate: endDate || new Date(2023, 1, 1),
  }
}
const getNextDay = (currentDayIdx) => {
  const nextDay = dayNames[currentDayIdx + 1];
  return nextDay || dayNames[0];
}
/**
 * @param {number} dayId
 * @param {string} weekDay
 */
const getDayRecurrence = (dayId, weekDay) => {
  return {
    recurrentStartDate: `on ${weekDay} at 0:00`,
    recurrentEndDate: `on ${getNextDay(dayId)} at 0:00`,
    isWorking: false
  };
}

class SwivuCalendarHelper {

  /**
   * @param {ProjectModel} project
   * @param {Object[]} records
   * @param {string} calendar
   */
  static addNonWorkingSlotsOnWeek(project, records, calendar = "weekends") {
    const weekendsCalendar = project.calendarManagerStore.getById(calendar);
    if (weekendsCalendar) {
      const intervals = records.filter((record) => record.allDay || (record.begin && record.end)).map((record) => record.allDay ? {
        ...getDayRecurrence(dayNames.findIndex((v) => v === record.dayName), record.dayName),
        id: record.id
      } : {
        id: record.id,
        isWorking: false,
        recurrentStartDate: `on ${record.dayName || " "} at ${record.begin || "0:00"}`,
        recurrentEndDate: `on ${record.dayName || " "} at ${record.end || "0:00"}`
      });
      weekendsCalendar.addIntervals(intervals);
    }
  }

  static clearNonWorkingIntervals(project, calendar = "weekends") {
    const weekendsCalendar = project.calendarManagerStore.getById(calendar);
    if (weekendsCalendar) {
      weekendsCalendar.clearIntervals();
    }
  }

  static reconfigureVisualNonWorkingDaysFromCalendar(scheduler, calendar = "weekends") {
    const project = scheduler.project;
    if (!project) return;
    const weekendsCalendar = project.calendarManagerStore.getById(calendar);

    if (weekendsCalendar) {
      const {startDate, endDate} = getSchedulerDates(scheduler);
      const nonWorkingTimeRangesInCalendar = weekendsCalendar
        .getNonWorkingTimeRanges(startDate, endDate);

      const nonWorkingTimeRanges = nonWorkingTimeRangesInCalendar.map((range, idx) => ({
        id: idx,
        startDate: range.startDate,
        endDate: range.endDate,
        cls: "swivu-non-working-time"
      })).filter((range) => {
        // when zooming in/out on scheduler on quarter and year there are some records found which has start date is
        // greater than the end date causing the error to be thrown on console and causing event drag on time-axis view to not work properly
        return range.startDate <= range.endDate;
      });

      project.timeRangeStore.clear();
      const eventState = scheduler.plugins.swivuSchedulerTimelineSort?.getSwivuSortState();
      if (eventState) {
        project.timeRangeStore.add({
          startDate: eventState.lastStartDate,
          endDate: eventState.lastEndDate,
          cls: "bg-time-event",
          recordType: "eventSort"
        })
      }
      project.timeRangeStore.add(nonWorkingTimeRanges);
    }
  }

  static reconfigureOnChange(scheduler, calendar = "weekends") {
    const {project} = scheduler;
    const intervalStore = project.calendarManagerStore.getCalendarById(calendar).intervalStore;
    const destroyIntervalListener = intervalStore.on("change", () => {
      SwivuCalendarHelper.reconfigureVisualNonWorkingDaysFromCalendar(scheduler);
    });

    return destroyIntervalListener;
  }

  static createWeekendCalendar = (project) => {
    if (!project.calendarManagerStore.getById("weekends")) {
      project.calendarManagerStore.add({
        id: 'weekends',
        name: 'Weekends',
        intervals: [],
      });
      if (project.hasCrudStore("calendars")) {
        project.removeCrudStore('calendars');
      }
    }
  }
}

export default SwivuCalendarHelper;
